<template>
  <div>
    <div>
      <POSDesktop></POSDesktop>
    </div>
    <!-- <div v-else>
            <POSMobile></POSMobile>
        </div> -->
  </div>
</template>

<script>
import POSDesktop from "./POSDesktop.vue";
//import POSMobile from "./POSMobile.vue";

export default {
  components: {
    POSDesktop,
    //POSMobile,
  },
  mounted() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
  },
  updated() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
  },

  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
};
</script>
